import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlatwareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flatware"}/>
}
